import { Injectable, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { MaterialService } from './material.service'
import { Material } from './material'

@Injectable({
  providedIn: 'root',
})
export class MaterialResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  private materialService = inject(MaterialService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public resolve(route: ActivatedRouteSnapshot): Observable<Material> {
    const id = route.paramMap.get('id')
    return this.materialService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
